export enum KeyCode {
    Enter = 13,
    UpArrow = 38,
    DownArrow = 40
}
 